import useSWR from "swr";
import API from "../../../axios/instances/API";
import { getClientTimezone } from "../../../storage/helpers";

const { timezoneEncoded } = getClientTimezone();

const BASE_URL = `/dashboard/home/`;

const fetcher = async ([url, locationId]) => {
  const { data } = await API.get(
    locationId
      ? `${url}?location_id=${locationId}&timezone=${timezoneEncoded}&version=2`
      : `${url}?timezone=${timezoneEncoded}&version=2`,
  );
  return data;
};

const useSupervisorHomeV2 = (locationId = null) => {
  const { data, error, mutate } = useSWR([BASE_URL, locationId], fetcher, {
    revalidateOnFocus: false,
    revalidateIfStale: false,
    revalidateOnReconnect: false,
  });

  return {
    data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};

export default useSupervisorHomeV2;
